import { render, staticRenderFns } from "./keyWord.vue?vue&type=template&id=36723481&scoped=true&"
import script from "./keyWord.vue?vue&type=script&lang=js&"
export * from "./keyWord.vue?vue&type=script&lang=js&"
import style0 from "./keyWord.vue?vue&type=style&index=0&id=36723481&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36723481",
  null
  
)

export default component.exports